module.exports = __webpack_public_path__ + "img/dot-pos.acd6417a.png";